import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '../views/LoginView.vue'
// import listadoFacturas from '../views/ListadoFacturasView.vue'
// import menuPrincipal from '../views/MenuView.vue'
// import { component } from 'vue/types/umd'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: login
  },
  {
    path: '/facturas',
    name: 'facturas',
    // component: listadoFacturas
    component: () => import('../views/ListadoFacturasCreditoView.vue')
  },
  {
    path: '/facturasRazonSocial',
    name: 'facturasRazonSocial',
    // component: listadoFacturas
    component: () => import('../views/ListadoFacturasCreditoRazonSocialView.vue')
  },
  {
    path: '/facturasEstaciones',
    name: 'facturasEstaciones',
    // component: listadoFacturas
    component: () => import('../views/ListadoFacturasCreditoEstacionView.vue')
  },
  {
    path: '/menuDebito',
    name: 'menuDebito',
    // component: menuPrincipal
    component: () => import('../views/MenuViewDebito.vue'),
  },

  {
    path: '/menuCredito',
    name: 'menuCredito',
    // component: menuPrincipal
    component: () => import('../views/MenuViewCredito.vue')
  },
  
  {
    path: '/estadoCuentaCredito',
    name: 'estadoCuentaCredito',
    // component: menuPrincipal
    component: () => import('../views/EstadoCuentaCreditoView.vue'),
  },

  {
    path: '/cupones',
    name: 'cupones',
    component: () => import('../views/CuponesView.vue'),
  },

  {
    path: '/movimientosCredito',
    name: 'movimientosCredito',
    component: () => import('../views/MovimientosCredito.vue')
  },
  
  {
    path: '/movimientosDebito',
    name: 'movimientosDebito',
    component: () => import('../views/MovimientosDebito.vue'),
  },
  {
    path: '/aplicacionPagoDebito',
    name: 'aplicacionPagoDebito',
    // component: menuPrincipal
    component: () => import('../views/AplicacionPagoDebitoView.vue'),
  },
  {
    path: '/aplicacionPagoCredito',
    name: 'aplicacionPagoCredito',
    // component: menuPrincipal
    component: () => import('../views/AplicacionPagoCreditoView.vue'),
  },
]

const router = new VueRouter({
  routes
})

export default router
